import React from "react";
import './backdrop.scss';

const BackdropApp = (props) => {
  return (
      <div className={'backdropBox'}>
        <div className="adDet adDet1"></div>
        <div className="adDet adDet2"></div>
        <div className="adDet adDet3"></div>
        <div className="adDet adDet4"></div>
        <div className="adDet adDet5"></div>
        <div className="adDet adDet6"></div>
      </div>
  )
};

export default BackdropApp;
